export default __webpack_public_path__ + "img/logo.a91986b8.png";